import { Application } from '@hotwired/stimulus';

const application = Application.start();

import OffCanvasController from './controllers/offcanvas_controller';
application.register('offcanvas', OffCanvasController);

import AnimatedHeadingController from './controllers/animated-heading_controller';
application.register('animated-heading', AnimatedHeadingController);

import StickyController from './controllers/2024/sticky_controller';
application.register('sticky', StickyController);

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const swiperWrapper = document.querySelector('.swiper-wrapper');
const swiperWrapperRect = swiperWrapper.getBoundingClientRect();
const swiperNavigation = document.querySelector('.swiper-navigation');

swiperNavigation.style.setProperty('--swiper-wrapper-height', `${swiperWrapperRect.height}px`);

new Swiper('.organizations-carousel', {
  // configure Swiper to use modules
  modules: [Pagination, Navigation],
  pagination: {
    modifierClass: 'swiper-pagination-',
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '"></span>';
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 1,
  spaceBetween: 28.8,
  shortSwipes: true,
  loop: true
});